import React, { useEffect, useState } from "react";
import LeftMenuSidebar from "../../../unicomponents/LeftMenuSidebar";
import useAllForms from "../../../hooks/useAllForms";
import { useLocation } from "react-router-dom";
import DropdownSchoolYear from "../../../unicomponents/Dropdowns/DropdownSchoolYear";
import DropdownTermDate from "../../../unicomponents/Dropdowns/DropdownTermDate";
import DropdownHierarchyOne from "../../../unicomponents/Dropdowns/DropdownHierarchyOne";
import DropdownHierarchyTwo from "../../../unicomponents/Dropdowns/DropdownHierarchyTwo";
import DropdownHierarchyThree from "../../../unicomponents/Dropdowns/DropdownHierarchyThree";
import DropdownUniqueUsersInDisplayData from "../../../unicomponents/Dropdowns/DropdownUniqueUsersInDisplayData";
import useOrganizationSetting from "../../../hooks/useOrganizationSetting";
import useTermPeriod from "../../../hooks/useTermPeriod";
import useRegistrationInfo from "../../../hooks/useRegistrationInfo";
import { useAuthContext } from "../../../context/AuthContext";
import { setTermIdByToday } from "../../../util/dateRelated";
import { generateRegistrationRows } from "../../../util/dealingArrObj";
import { filterSettingsByStudentsPath } from "../../../util/specialCase";
import { checkHrteachers } from "../../../util/checkPermissions";
import { useTranslation } from "react-i18next";
import StudentGrades from "./studentGrades/StudentGrades";

export default function StudentRecordsView() {
  const location = useLocation();
  const paths = location.pathname.split("/");
  const schoolId = paths[1];

  const conditions = {
    schoolid: schoolId,
    form_category: "studentRecordsView",
  };

  const [filters, setFilters] = useState({
    schoolYear: null,
    schoolYearId: "",
    hierarchyOneId: "",
    levelOneName: "",
    hierarchyTwoId: "",
    hierarchyThreeId: "",
    organPathForSort: "/",
    termId: "",
    selectedLessonId: "",
    selectedStudent: "",
  });
  const [termId, setTermId] = useState("");
  const [currentPeriod, setCurrentPeriod] = useState({});
  const [studentList, setStudentList] = useState([]);
  const [newSetting, setNewSetting] = useState([]);
  const [selectedStudentData, setSelectedStudentData] = useState({});

  const [activeMenu, setActiveMenu] = useState({
    menu_name: "",
    menu_id: "",
    options: {},
  });

  const {
    allFormsQuery: { data: allFormsData },
  } = useAllForms(conditions);

  const {
    settingQuery: { data: settingData },
  } = useOrganizationSetting({ schoolid: schoolId });

  const {
    termPeriodQuery: { data: termPeriodData },
  } = useTermPeriod({ schoolid: schoolId });

  // 교사용 - 전체 학생 데이터 조회
  const {
    registrationInfoQuery: { data: registrationInfoData },
    hrTeachersQuery: { data: hrTeachersData },
  } = useRegistrationInfo(
    { schoolid: schoolId },
    { registrationInfo: true, hrTeachers: true }
  );

  const { user, hasPermission } = useAuthContext();

  const { t } = useTranslation();

  useEffect(() => {
    if (allFormsData) {
      // console.log("allFormsData[0].form_name", allFormsData);
      setActiveMenu({
        menu_name: allFormsData[0].form_name,
        menu_id: allFormsData[0].id,
        options: allFormsData[0].options,
      });
    }
  }, [allFormsData]);

  useEffect(() => {
    let initialSchoolYear = null;
    let initialSchoolYearId = null;
    let initialData = [];
    if (
      filters.schoolYear === null &&
      newSetting &&
      newSetting.length > 0 &&
      registrationInfoData
    ) {
      initialData = newSetting
        .sort((a, b) => a.hierarchy_level - b.hierarchy_level)
        .sort((a, b) => b.school_year - a.school_year);

      // console.log("initialData", initialData);
      if (initialData.length < 1) {
        alert(t("common.messages.registrationError"));
        return;
      }

      initialSchoolYear = initialData[0].school_year;
      initialSchoolYearId = initialData[0].id;

      setFilters((filters) => ({
        ...filters,
        schoolYear: initialSchoolYear,
        schoolYearId: initialSchoolYearId,
      }));

      if (termPeriodData) {
        setTermIdByToday(termPeriodData, setTermId, initialSchoolYearId);
      }

      if (initialSchoolYear) {
        //학생 리스트
        const sortedRows = generateRegistrationRows(
          registrationInfoData,
          newSetting,
          initialSchoolYear,
          filters.organPathForSort
        );
        setStudentList(sortedRows);
      }
    } else {
      //rows 데이터처리
      if (registrationInfoData && newSetting) {
        const sortedRows = generateRegistrationRows(
          registrationInfoData,
          newSetting,
          filters.schoolYear,
          filters.organPathForSort
        );

        setStudentList(sortedRows);
      }
    }
  }, [
    filters.schoolYear,
    filters.organPathForSort,
    registrationInfoData,
    newSetting,
    termPeriodData,
    user?.username,
    t,
  ]);

  // 교사용 데이터 처리 - 권한에 따른 학생 데이터 필터링
  useEffect(() => {
    if (registrationInfoData && settingData) {
      let filteredData = registrationInfoData;

      // 권한에 따른 데이터 필터링
      if (!hasPermission(null, "can_read")) {
        // can_read 권한이 없으면 담임 학생들만 조회
        if (hrTeachersData && user?.username) {
          const teacherClasses = hrTeachersData.filter((hr) =>
            hr.hr_teacher_username?.some(
              (teacher) => teacher.username === user.username
            )
          );

          if (teacherClasses.length > 0) {
            const allowedPaths = teacherClasses.map(
              (hr) => hr.organization_path
            );
            filteredData = registrationInfoData.filter((student) =>
              allowedPaths.includes(student.organization_path)
            );
          } else {
            filteredData = []; // 담임이 아니면 데이터 없음
          }
        } else {
          filteredData = []; // 권한 없음
        }
      }

      // 설정 데이터 생성 (기존 로직 유지)
      setNewSetting(filterSettingsByStudentsPath(filteredData, settingData));
    }
  }, [
    registrationInfoData,
    settingData,
    hrTeachersData,
    user?.username,
    hasPermission,
  ]);

  useEffect(() => {
    if (termPeriodData) {
      const nowPeriod = termPeriodData.filter(
        (r) => r.id.toString() === termId.toString()
      )[0];

      if (nowPeriod) {
        setCurrentPeriod(nowPeriod);
      } else {
        setCurrentPeriod({});
      }
    }
  }, [termId, termPeriodData]);

  // 선택된 학생 데이터 설정
  useEffect(() => {
    if (filters.selectedStudent && studentList.length > 0) {
      const selectedStudent = studentList.find(
        (student) => student.username === filters.selectedStudent
      );

      if (selectedStudent) {
        // StudentGrades에서 필요한 데이터 구조로 변환
        const studentData = {
          ...selectedStudent,
          schoolid: schoolId,
          schoolYearDates: [
            {
              school_year_id: filters.schoolYearId,
            },
          ],
        };
        setSelectedStudentData(studentData);
      } else {
        setSelectedStudentData({});
      }
    } else {
      setSelectedStudentData({});
    }
  }, [filters.selectedStudent, studentList, schoolId, filters.schoolYearId]);

  /*
  const handleDropdownChange = (e) => {
    const { name, value } = e.target;
    const selectedOptionText = e.target.selectedOptions[0].text;

    if (name === "0") {
      setFilters((filters) => ({
        ...filters,
        schoolYear: selectedOptionText,
        schoolYearId: value,
        hierarchyOneId: "",
        hierarchyTwoId: "",
        hierarchyThreeId: "",
        selectedStudent: "",
        organPathForSort: "/",
      }));

      setTermIdByToday(termPeriodData, setTermId, value);
    }

    if (name === "1") {
      setFilters((filters) => ({
        ...filters,
        hierarchyOneId: value,
        hierarchyTwoId: "",
        hierarchyThreeId: "",
        selectedStudent: "",
        organPathForSort: value ? `/${value}/` : "/",
      }));
    }

    if (name === "2") {
      setFilters((filters) => ({
        ...filters,
        hierarchyTwoId: value,
        hierarchyThreeId: "",
        selectedStudent: "",
        organPathForSort:
          value && filters.hierarchyOneId
            ? `/${filters.hierarchyOneId}/${value}/`
            : filters.hierarchyOneId
            ? `/${filters.hierarchyOneId}/`
            : "/",
      }));
    }

    if (name === "3") {
      setFilters((filters) => ({
        ...filters,
        hierarchyThreeId: value,
        selectedStudent: "",
        organPathForSort:
          value && filters.hierarchyTwoId && filters.hierarchyOneId
            ? `/${filters.hierarchyOneId}/${filters.hierarchyTwoId}/${value}/`
            : filters.hierarchyTwoId && filters.hierarchyOneId
            ? `/${filters.hierarchyOneId}/${filters.hierarchyTwoId}/`
            : filters.hierarchyOneId
            ? `/${filters.hierarchyOneId}/`
            : "/",
      }));
    }

    if (name === "students") {
      setFilters((filters) => ({
        ...filters,
        selectedStudent: value,
      }));
    }

    if (name === "termDate") {
      setTermId(value);
    }
  };
*/

  const handleDropdownChange = (e) => {
    const { name, value } = e.target;
    const selectedOptionText = e.target.selectedOptions[0].text;
    const dataName = e.target.selectedOptions[0].getAttribute("data-name");
    let organPath = "";
    if (!dataName) {
      organPath = "N/A";
    } else {
      organPath = dataName + "/" + value;
    }
    if (name === "0") {
      setFilters((filters) => ({
        ...filters,
        schoolYear: selectedOptionText,
        schoolYearId: value,
        hierarchyOneId: "",
        organPathForSort: "N/A",
        selectedStudent: "",
      }));

      setTermIdByToday(termPeriodData, setTermId, value);
    }

    if (name === "1") {
      setFilters((filters) => ({
        ...filters,
        hierarchyOneId: value,
        hierarchyTwoId: "",
        hierarchyThreeId: "",
        organPathForSort: "N/A",
        selectedStudent: "",
      }));

      setTermIdByToday(termPeriodData, setTermId, filters.schoolYearId, value);
    }

    if (name === "2") {
      setFilters((filters) => ({
        ...filters,
        hierarchyTwoId: value,
        hierarchyThreeId: "",
        organPathForSort: "N/A",
        selectedStudent: "",
      }));

      setTermIdByToday(
        termPeriodData,
        setTermId,
        filters.schoolYearId,
        filters.hierarchyOneId,
        value
      );
    }

    if (name === "3") {
      setFilters((filters) => ({
        ...filters,
        hierarchyThreeId: value,
        organPathForSort: organPath,
        selectedStudent: "",
      }));
    }

    if (name === "students") {
      setFilters((filters) => ({
        ...filters,
        selectedStudent: value,
      }));
    }

    if (name === "termDate") {
      setTermId(value);
    }
  };

  const renderComponent = () => {
    // 두 조건 모두 만족하지 않으면 early return
    if (
      !checkHrteachers(
        hrTeachersData,
        filters.selectedStudent,
        filters.schoolYear
      ) &&
      !hasPermission(null, "can_read")
    ) {
      return (
        <div className="alert alert-warning mt-4">
          <p>{t("common.messages.homeroomReadOnly")}</p>
        </div>
      );
    }

    switch (activeMenu.menu_name) {
      case "studentGrades":
        return (
          <StudentGrades
            keyData={selectedStudentData}
            currentPeriod={currentPeriod}
          />
        );
      default:
        return (
          <StudentGrades
            keyData={selectedStudentData}
            currentPeriod={currentPeriod}
          />
        );
    }
  };

  return (
    <div className="basicWidth">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12 col-md-2">
            <LeftMenuSidebar
              activeMenu={activeMenu}
              setActiveMenu={setActiveMenu}
              menuData={allFormsData}
              itemName="form_name"
              itemLabel="form_label"
            />
          </div>
          <div className="col-12 col-md-10">
            <div
              className="d-flex justify-content-end gap-2 flex-wrap mt-4"
              style={{ width: "100%" }}
            >
              <div style={{ width: "95px" }} className="me-1">
                <DropdownSchoolYear
                  settingData={newSetting}
                  handleDropdownChange={handleDropdownChange}
                  schoolYearId={filters.schoolYearId}
                  allYears={false}
                />
              </div>
              <div style={{ width: "95px" }} className="me-1">
                <DropdownHierarchyOne
                  settingData={settingData}
                  handleDropdownChange={handleDropdownChange}
                  schoolYear={filters.schoolYear}
                  hierarchyOneId={filters.hierarchyOneId}
                  hierarchyOneTitle={t("common.labels.schoolStage") || "과정"}
                  extraOption={false}
                />
              </div>
              <div style={{ width: "95px" }} className="me-1">
                <DropdownHierarchyTwo
                  settingData={settingData}
                  handleDropdownChange={handleDropdownChange}
                  schoolYear={filters.schoolYear}
                  hierarchyOneId={filters.hierarchyOneId}
                  hierarchyTwoId={filters.hierarchyTwoId}
                  hierarchyTwoTitle={t("common.labels.studentYear") || "학년"}
                  extraOption={false}
                  disabled={!filters.hierarchyOneId}
                />
              </div>
              <div style={{ width: "95px" }} className="me-1">
                <DropdownHierarchyThree
                  settingData={settingData}
                  handleDropdownChange={handleDropdownChange}
                  schoolYear={filters.schoolYear}
                  hierarchyTwoId={filters.hierarchyTwoId}
                  hierarchyThreeId={filters.hierarchyThreeId}
                  hierarchyThreeTitle={t("common.labels.class") || "반"}
                  extraOption={false}
                  disabled={!filters.hierarchyTwoId}
                />
              </div>
              <div style={{ width: "120px" }} className="me-1">
                <DropdownUniqueUsersInDisplayData
                  displayData={studentList}
                  displayKey={"fullname"}
                  valueKey={"username"}
                  filters={{ organization_path: filters.organPathForSort }}
                  uniqueKey={"username"}
                  sortKey={"studentno"}
                  isDesc={false}
                  handleDropdownChange={handleDropdownChange}
                  selectedUser={filters.selectedStudent}
                  selectName={"students"}
                  styleClass={"form-control"}
                  dropdownTitle={t("common.user.student") || "학생"}
                  required={true}
                  disabled={!filters.hierarchyThreeId}
                />
              </div>
              <div style={{ width: "95px" }}>
                <DropdownTermDate
                  termPeriodData={termPeriodData}
                  handleDropdownChange={handleDropdownChange}
                  termId={termId}
                  schoolYearId={filters.schoolYearId}
                />
              </div>
            </div>
            <div>
              {" "}
              {/*여기 아래가 바뀌어서 들어갈 곳 */}
              {filters.selectedStudent ? (
                renderComponent()
              ) : (
                <div className="alert alert-info mt-4">
                  <h5>
                    {t("teacher.studentRecordsView.selectStudentMessage") ||
                      "학생을 선택해주세요"}
                  </h5>
                  <p>
                    {t("teacher.studentRecordsView.selectStudentDescription") ||
                      "학년도, 과정, 학년, 반, 학생을 순서대로 선택하면 해당 학생의 기록을 확인할 수 있습니다."}
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
